module.exports = __webpack_public_path__ + "img/1516674251.c66c652e.jpg";